import {getHexKeysInRange} from "../../coords/getHexKeysInRange";
import {isUnitFaction} from "../isUnitFaction";
import {FACTIONS} from "../../../constants/factions";
import {GOBLINS_ABILITY_RADIUS, GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY} from "../../../configs/factions/goblins";
import {hasAdjacentEnemyUnit} from "../../gameState/hasAdjacentEnemyUnit";
import {hasObstacleInPath} from "../../gameState/shooting/calculateAvailableShootingCells";

/**
 * Гексы со СВОИМИ ловушками, доступные для снятия: радиус
 * GOBLINS_ABILITY_RADIUS от отряда И прямая видимость (нет горы/непобеждённой
 * крепости на линии — та же hasObstacleInPath, что и у соблазнения Суккубов).
 * Чужие ловушки (в т.ч. других игроков-гоблинов) сюда не попадают.
 */
export const calculateAvailableTrapRemovalCells = (
  units, goblinsTraps, selectedUnit, hexes, specialBuildings, buildingsDamage, fortressesUnderConstruction
) => {
  if (!selectedUnit
    || !isUnitFaction(selectedUnit, FACTIONS.GOBLINS)
    || selectedUnit.hasUsedAbilityThisWarPhase
    || selectedUnit.size < GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY
  ) {
    return [];
  }

  if (hasAdjacentEnemyUnit(selectedUnit.hexKey, selectedUnit.ownerId, units)) {
    return [];
  }

  const rangeHexKeys = new Set(getHexKeysInRange(selectedUnit.hexKey, GOBLINS_ABILITY_RADIUS));

  return goblinsTraps
    .filter(trap => trap.ownerId === selectedUnit.ownerId && rangeHexKeys.has(trap.hexKey))
    .filter(trap => !hasObstacleInPath(
      selectedUnit.hexKey, trap.hexKey, hexes, specialBuildings, [], buildingsDamage, fortressesUnderConstruction
    ))
    .map(trap => trap.hexKey);
};
